import { Editor } from "tinymce";
import { registerBoxTypes } from "./type.box.plugin";
import { registerBoxAlignment } from "./alignment.box.plugin";
import { registerBoxWidth } from "./width.box.plugin";
import { registerAccordionBox } from "./accordion.box.plugin";
import { registerBoxColors } from "./color.box.plugin";


export const register = (editor: Editor) => {

    editor.ui.registry.addContextToolbar('infoblock', {
        predicate: (t) => t.classList.contains('mds-box-format'),
        items: 'box-type box-color | toggle-outline | aligncenter alignright | box-alignment box-width',
        position: 'node',
        scope: 'node'
    });

    registerBoxTypes(editor);
    registerBoxAlignment(editor);
    registerBoxWidth(editor);
    registerAccordionBox(editor);
    registerBoxColors(editor);
}